
export default {
  props: {
    refId: {
      type: String,
      default: '',
    },
    articleUrl: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
    categorySlug: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    blackLine: {
      type: Boolean,
      default: true,
    },
    imageRatio: {
      type: Object,
      default: null,
    },
  },

  computed: {
    customProperties() {
      return {
        '--desktop-width': this.imageRatio['desktop-width'],
        '--desktop-height': this.imageRatio['desktop-height'],
        '--mobile-width': this.imageRatio['mobile-width'],
        '--mobile-height': this.imageRatio['mobile-height'],
      }
    },
  },
}
